'use client'
import Image from 'next/image'
import Link from 'next/link'
import React, { Suspense } from 'react'
import MobileNav from './layouts/Share/MobileNav/MobileNav'
import Header from './layouts/Share/Header/Header'
import BackgroundLayout from './components/ui/BgSection/BackgroundLayout'


export const metadata = {
  title: 'AI Search Engine & DeFi Tools for Web3 | Hero.io'
}
function NotFound () {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <MobileNav />
      <div className='w-full h-screen  relative'>
        <Header hasCryptoMarquee={false} />
        <BackgroundLayout>
          <section className=' flex pb-40 md:pb-40 items-center 2xl:items-center justify-center h-screen'>
            <div className='text-center fade-in'>
              <div className='w-[300px] 2xl:w-[600px] 2xl:h-[633px] h-[313px] relative mx-auto mb-4'>
                <Image
                  src='/imgs/hero_new_bot.png'
                  fill
                  alt='Hero Image'
                  className='mx-auto mb-4 bounce w-[300px] 2xl:w-[600px] xl'
                  priority
                />
              </div>
              <h1 className='md:text-6xl text-3xl 2xl:pb-2 2xl:text-[60px]  font-bold text-primary-slate-700 mb-4'>
                Page Not Found
              </h1>
              <p className='md:text-xl text-[12px] 2xl:py-3 2xl:text-[30px] text-hero-blue-500 mb-6'>
                Sorry, the page you are looking for does not exist.
              </p>
              <Link href='/' className='inline-block'>
                <div className='text-sm sm:text-base font-bold flex w-full lg:max-w-fit  h-[50px] '>
                  <button className='outline-none border-none bg-hero-pink-200 dark:text-white rounded-full w-full px-6 text-white flex  shadow-xl hover:opacity-90'>
                    <span className='m-auto object-fill'>Back To Home</span>
                  </button>
                </div>
              </Link>
            </div>
          </section>
        </BackgroundLayout>
      </div>
    </Suspense>
  )
}
export default NotFound
